<template>
  <DBox
    :id="'cmp-catalog-products-harry-fox'"
    :addButton="false"
    :rightMenu="[
      {
        value: 'select_mechanical_rate',
        text: $t('select_mechanical_rate'),
      },
    ]"
    @menuClick="onMenuClick"
  >
    <TextField2
      :disabled="true"
      :id="'excess_mechanical_rate'"
      :ta="'right'"
      :type="'percent'"
      :placeholder="$t('excess_mechanical_rate')"
      :label="$t('excess_mechanical_rate')"
      :value="selectedProductDetails.product.excess_mechanical_rate"
      @blur="onTextFieldValueChange"
    />
  </DBox>
</template>

<script>
export default {
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  methods: {
    onMenuClick(value) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_mechanical_rate",
          external_id: this.selectedProductDetails.product.product_id,
          catalog_no: this.selectedProductDetails.catalog_no,
        },
      });
    },
    onTextFieldValueChange: function (event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function (name, value) {
      this.$emit("changed", { name, value: value.value });
    },
  },
};
</script>
